import React from 'react'
import { api as apiAlias } from '../api/alias'
import { api as apiGroup } from '../api/group'
import { type Group } from '../api/types'
import NewOrMoveAlias, { type ActionResult } from './aliasManage'

export const AliasNew: React.FC = () => {
  const createNewAlias: (
    newAlias: string,
    newRecipients: string[],
    selectedCandidate: Group,
    createNewGroup: boolean,
    description: string,
    expires: string
  ) => Promise<ActionResult> = async (
    newAlias,
    newRecipients,
    selectedCandidate,
    createNewGroup,
    description,
    expires
  ) => {
    const fullAlias = `${newAlias}@lunenetworks.com`

    if (createNewGroup) {
      return await apiGroup
        .create({
          name: selectedCandidate.name,
          email: selectedCandidate.email,
          members: newRecipients,
          aliases: [],
          createRequest: {
            aliases: [{ alias: fullAlias, description, expires }]
          }
        })
        .then<ActionResult>(() => ({
          effect: 'added',
          effectOn: fullAlias,
          severity: 'success',
          message: 'Email created OK'
        }))
        .catch<ActionResult>((err: Error) => ({
          effect: 'errored',
          effectOn: fullAlias,
          severity: 'error',
          message: err.message
        }))
    }

    return await apiAlias
      .create(selectedCandidate.email, {
        group: selectedCandidate.email,
        alias: fullAlias,
        description,
        expires
      })
      .then<ActionResult>(() => ({
        effect: 'added',
        effectOn: fullAlias,
        severity: 'success',
        message: 'Email created OK'
      }))
      .catch<ActionResult>((err: Error) => ({
        effect: 'errored',
        effectOn: fullAlias,
        severity: 'error',
        message: err.message
      }))
  }

  return (
    <NewOrMoveAlias
      action="Create"
      title="Add New Email Alias"
      targetGroupLabel="Create in"
      onAction={createNewAlias}
    />
  )
}
